import { render, staticRenderFns } from "./profile-contacts.vue?vue&type=template&id=49462158&"
import script from "./profile-contacts.vue?vue&type=script&lang=js&"
export * from "./profile-contacts.vue?vue&type=script&lang=js&"
import style0 from "./profile-contacts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49462158')) {
      api.createRecord('49462158', component.options)
    } else {
      api.reload('49462158', component.options)
    }
    module.hot.accept("./profile-contacts.vue?vue&type=template&id=49462158&", function () {
      api.rerender('49462158', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/account/profile-contacts.vue"
export default component.exports